export const trackingBasedOnState = function trackingBasedOnState(identifier, oldState, newState, action) {
    // eslint-disable-next-line curly
    if (oldState[identifier] !== newState[identifier]) action(oldState, newState);
};
